import styled from 'styled-components';

export const StyledBackground = styled.div`
  height: ${(props: any) => props.height};
  min-height: ${(props: any) => props.minHeight};
  width: ${(props: any) => props.width};
  background-color: ${(props: any) => props.backgroundColor};
  background-image: url(${(props: any) => props.backgroundImage});
  background-repeat: no-repeat;
  background-size: ${(props: any) => props.backgroundSize};
  background-position: ${(props: any) => props.backgroundPosition};
  position: ${(props: any) => props.position};
  top: 0;
  left: 0;
  z-index: 0;
  overflow-y: scroll !important;
  overflow-x: hidden;

  @media (min-width: 1024px) {
    overflow: unset !important;
  }

  // landscape
  @media screen and (min-width: 500px) and (max-width: 950px) and (orientation: landscape) and (height < 500px) {
    overflow: unset !important;
  }
` as any;
